import React, { Component } from 'react';
import { Button, ButtonGroup} from '@material-ui/core';
import { Card, Col } from 'react-bootstrap';

import img from '../../../images/john.png';

export default class  CardCandidate extends Component{
    render(){
        return(
        <Card className="bg-white shadow p-2 border-0">
            <div className="text-center pb-3">
                 <img src={img} alt="interview img" width="100" className="rounded-circle" />  
            </div>
            <div className="text-center">
                <div><strong>John Doe</strong></div>
                <div><p className="text-grey mb-0">Senior Web Developer</p></div>
                <div><p className="text-grey">Cairo, Egypt</p></div>
                <Col xs='12 p-0 pb-2'>
                    <Button className="p-0 mr-1" variant="outlined" disabled>
                            Adobe XD
                        </Button>
                        <Button className="p-0 mr-1" variant="outlined" disabled>
                            Graphic
                        </Button>
                        <Button className="p-0" variant="outlined" disabled>
                            Design
                        </Button>
                </Col>
                <Button variant="outlined" className="w-100 btn-orange-outline-gradiant pb-1 pt-1" color="primary" size="large">Shortlisted</Button>
            </div>
        </Card>);
    }
}
